import Parse from 'parse';

Parse.serverURL = process.env.REACT_APP_PARSE_URL ?? '';
Parse.initialize('Hcwnq8U7xN4Z2bXcSBdvv4bjfRNKCpPSahXgeq9xRp');
